import { ListingCard } from './ListingCard'

export default ListingCard
